import PhotoSwipeLightbox from 'photoswipe/lightbox';

const start = () => {
  const lightbox = new PhotoSwipeLightbox({
    gallery: 'body',
    children: 'a[data-gallery]',
    showHideAnimationType: 'none',
    pswpModule: () => import('photoswipe')
  });
  lightbox.init();
};

export default { start };
